import React, { useCallback } from 'react';

import Button from '~/components/Button';
import SpinnerOverlay from '~/components/SpinnerOverlay';
import UploadFile from '~/components/UploadFile';
import { PICTURE_REJECT_REASONS } from '~/values/enums';

import styles from './PersonPicture.module.scss';
import PictureModal from './PictureModal';

const PictureButton = ({
    personId,
    form,
}) => {
    const onClickWebcam = useCallback(() => {
        PictureModal.show({
            personId,
            onChangePicture: picture => {
                form.change('images', [picture]);
            },
        });
    }, [form, personId]);

    return (
        <Button
            onClick={onClickWebcam}
        >
            Tirar foto
        </Button>
    );
};

const PersonPicture = ({
    images,
    photoValidated, personId, form,
    isLoadingValidation,
}) => {

    const renderPhotoValidation = () => {
        if (isLoadingValidation) {
            return (
                <div className={styles.avatarLabel}>
                    <SpinnerOverlay spinning tip="Validando foto..." />
                </div>
            );
        }

        if (!images?.length) {
            return (
                <div className={styles.avatarLabel}>
                    SEM FOTO
                </div>
            );
        }

        if (!photoValidated) {
            return (
                <div className={styles.avatarLabel}>
                    VALIDAÇÃO PENDENTE, CLIQUE EM SALVAR
                </div>
            );
        }

        if (!photoValidated.valid && photoValidated.rejectionReason) {
            return (
                <div className={styles.avatarLabelInvalidated}>
                    {PICTURE_REJECT_REASONS.getLabelByKey(photoValidated.rejectionReason)}
                </div>
            );
        }

        return (
            <div className={styles.avatarLabelValidated}>
                FOTO VALIDADA
            </div>
        );
    };

    return (
        <div className={styles.avatar}>
            <div className={styles.avatarContainer}>
                <UploadFile.Field
                    width={250}
                    height={250}
                    name="images"
                    maxFiles={1}
                    accept="image/*"
                />
                {renderPhotoValidation()}
                <PictureButton
                    personId={personId}
                    form={form}
                />
            </div>
        </div>
    );
};

export default PersonPicture;
